/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 优惠券id
   */
  coupon_id: string;
}
export interface PublicCouponQueryOneRes {
  code: number;
  msg: string;
  nonce: string;
  data: Data;
}
export interface Data {
  coupon: Coupon;
}
export interface Coupon {
  /**
   * 优惠券id
   */
  coupon_id: string;
  /**
   * 面额，单位分
   */
  coupon_value: number;
  /**
   * 开始有效时间
   */
  begin_time: number;
  /**
   * 结束有效时间
   */
  end_time: number;
  /**
   * 用户使用优惠券状态。0未领取，1已领取，2已使用
   */
  user_coupon_state: number;
  /**
   * 优惠券状态。0正常，1未开始，2过期，3领取完了，4删除，5下架
   */
  coupon_state: string;
  /**
   * 活动名称
   */
  event_name: string;
  /**
   * 优惠券门槛（分）
   */
  threshold: number;
  event_id: string;
}

const PublicCouponQueryOne = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<PublicCouponQueryOneRes>(
    '/wemeet-tapi',
    '/v2/activities/public/coupon/query-one',
    data,
    ctx,
  );

  return res;
};

export default PublicCouponQueryOne;
